export default "__VITE_ASSET__ew2xj1m8yAIpPRH3jxr$Zw__"